<template>
  <div id="free-mortgagewatch">
    <a id="introduction"></a>
    <HeroSection :size="size" :theme="theme">
      <div class="row justify-content-lg-between align-items-lg-center mb-5">
        <div class="col-lg-6 mb-6 mb-lg-0 pb-3 px-3">
          <h1 class="font-size-4 text-warning">Get your FREE MortgageWatch Alert</h1>
          <p class="text-white-70 h3 mt-3 mb-4">
            It only takes a few moments to create and then you're done ... we'll take care of the rest.
          </p>
          <div class="sd-flex align-items-center flex-wrap pt-3">
            <router-link
                to="/mortgage-watch/getting-started"
                v-slot="{ href, route, navigate }">
              <button class="btn btn-light w-lg-75 w-sm-100" style="min-width: 50%" :href="href" @click="navigate">Get FREE MortgageWatch Alert</button>
            </router-link>
          </div>
          <!-- End Info -->
        </div>

        <div class="col-lg-6 dd-none d-lg-inline-block text-center">
          <!-- SVG Icon -->
          <figure>
            <img class="js-svg-injector img-fluid w-lg-90 w-sm-75" src="/assets/cmc/svg/components/macbook-too.png" alt="Image Description">
          </figure>
          <!-- End SVG Icon -->
        </div>
      </div>
    </HeroSection>
  </div>
</template>

<script>
import HeroSection from "@/components/layout/HeroSection";
export default {
  name: "FreeMortgageWatchAlert",
  components: {HeroSection},
  
  props: {
    theme: {
      type: String,
      default: "home/free-mortgagewatch-alert"
    },
    size: {
      type: String,
      default: "lg"
    }
  }
};
</script>
